import { reducers } from "./last-action.reducers";
export const Store = {
    featureKey: "lastAction",
    initialState: { actionType: null },
    reducers,
};
